export enum VildVersionStatusType {
  uploaded = 'uploaded',
  imported = 'imported',
  matched = 'matched',
  approved = 'approved'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/vildversionstatustype.ts